module.exports = __webpack_public_path__ + "static/media/m256.1da47e0f.jpg";